import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MarkdownComponent, MarkdownModule } from 'ngx-markdown';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { HttpClientModule } from '@angular/common/http';
import { MatRadioModule } from '@angular/material/radio';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FindUserPipe } from '../pipes/find-user.pipe';
import { MatDialogModule } from '@angular/material/dialog';
import { BannerMessageComponent } from '../components/common/banner-message/banner-message.component';
import { FooterComponent } from '../components/common/footer/footer.component';
import { HeaderComponent } from '../components/common/header/header.component';
import { PageLayoutComponent } from '../components/common/page-layout/page-layout.component';
import { SafeUrlPipe } from '../pipes/safe-url.pipe';
import { NewlineToBreakPipe } from '../pipes/newline-to-break.pipe';
import { UtcToTimezonePipe } from '../pipes/utc-to-time-zone.pipe';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ToastComponent } from '../components/common/toast/toast.component';

@NgModule({
  declarations: [
    FindUserPipe,
    BannerMessageComponent,
    ToastComponent,
    NewlineToBreakPipe,
    SafeUrlPipe,
    UtcToTimezonePipe,
    HeaderComponent,
    FooterComponent,
    PageLayoutComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    MarkdownModule.forRoot(), // Correct usage of MarkdownModule
    MatToolbarModule,
    MatInputModule,
    MatCardModule,
    MatDialogModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatTableModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatOptionModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSnackBarModule,
    MatRadioModule,
    RouterModule,
    MatPaginatorModule,
  ],
  exports: [
    BannerMessageComponent,
    ToastComponent,
    CommonModule,
    FindUserPipe,
    FormsModule,
    HttpClientModule,
    MarkdownModule,
    MatToolbarModule,
    MatInputModule,
    MatCardModule,
    MatDialogModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatTableModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatOptionModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSnackBarModule,
    MatRadioModule,
    NewlineToBreakPipe,
    RouterModule,
    SafeUrlPipe,
    UtcToTimezonePipe,
    HeaderComponent,
    FooterComponent,
    PageLayoutComponent,
    MatPaginatorModule,
  ],
})
export class SharedModule {}
